import React, { Component } from 'react'
import { connect } from 'react-redux'
import { updateFillValue } from '../actions/index'

var $ = window.$

class Slider extends Component {
  constructor(props) {
    super(props)
    this.state = {
      end: this.props.answers.length-1,
      value: 0,
      tmpSlider: ''
    }
  }
  componentDidMount() {
    var self = this;
    $(this.$el)
      .on('change.fndtn.slider', function(e) {
        self.setState((state) => {
          return {
            value: $(e.target).attr('data-slider')
          }
        })
      });
    $(this.$el).foundation('slider','reflow');
  }
  componentDidUpdate(prevProps, prevState) {
    if (this.state.value !== prevState.value) {
      var nv = this.state.value
      var ov = prevState.value
      var nvi = Number(nv);
      if (Number.isInteger(nvi) && nvi>=0 && nvi<=this.state.end) {
        this.settmpSlider(null)
        $(this.$el).foundation('slider', 'set_value', nv);
        var newValue = this.props.gap.answers[nv].value || this.props.gap.answers[nv] || nv;
        this.props.dispatch(updateFillValue(newValue))
      } else if ( nv=='other' ) {
        this.props.dispatch(updateFillValue(nv))
      } else {
        this.settmpSlider(ov)
      }
    }
  }
  componentWillUnmount() {
    $(this.$el).foundation('_destroy');
  }
  settmpSlider = (value) => {
    this.setState((state) => {
      return {
        tmpSlider: value
      }
    })
  }
  handleSliderClick = () => {
    if(this.state.value=='other') {
      this.setState((state) => {
        value: state.tmpSlider
      })
    }
  }
  handleSliderButtonClick = () => {
    if(this.state.value=='other') {
      this.setState((state) => {
        value: (state.tmpSlider ? state.tmpSlider : 'other')
      })
    }
  }

  render() {
    var { answers } = this.props

    var sliderText = answers.map((answer, index) => {
      <span className="range-slider-text-container" key={index} style={'left:'+(index * (100/this.state.end) )+'%;'}>
        <span className="range-slider-text">{ answer.text || answer || index }</span>
      </span>
    })


    return(
      <div className="slider">
        <div className="row">
          <div className="small-12 columns">
            <div className={'range-slider radius ' + (this.state.value=='other' ? 'disabled' : '')}
               data-slider ref={(slider) => this.$el = slider}
            onClick={this.handleSliderClick}
            data-options={'start: 0; end:'+this.state.end+'; step:1;'} >
              <span className="range-slider-handle" role="slider" tabIndex="0"></span>
              <span className="range-slider-active-segment"></span>
              {sliderText}
            </div>
            <div className="slider-button" onClick={this.handleSliderButtonClick}>
              <input type="checkbox" checked={this.state.value=='other'}/>
                <label htmlFor="slider-alternative" className="prettyradio"></label>
                <label htmlFor="slider-alternative">Don't know/Not sure</label>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
    gap: state.app.gap
  }
)

const Container = connect(mapStateToProps)(Slider);

export default Container;



// WEBPACK FOOTER //
// ./src/components/Slider.js